import { Button } from '@unified-checkout/design-system';

import type {
  IAnnouncementBox,
  IProgressBox,
  TAnnouncementProgressBox,
} from '@app/dashboard/types/innerLayout/announcement-box';
import { Birds } from '@app/dashboard/assets/icons';
import { ANNOUNCEMENTS_TYPES } from '@app/dashboard/constants/announcements';

import styles from './announcement-box.module.scss';

export const AnnouncementBox = (props: TAnnouncementProgressBox) => {
  const {
    title,
    description,
    icon,
    actionBtnsProps,
    show = true,
    type = ANNOUNCEMENTS_TYPES.ANNOUNCEMENT,
    status,
  } = (props as IProgressBox & IAnnouncementBox) || {};

  const isAnnouncement = type === ANNOUNCEMENTS_TYPES.ANNOUNCEMENT;

  if (!show) return null;

  return (
    <div
      className={styles['announcement-bar']}
      data-announcement-type={type}
      data-announcement-status={!isAnnouncement && status}
    >
      {isAnnouncement && (
        <div className={styles['announcement-bar__aesthetic-icon']}>
          {Birds}
        </div>
      )}

      {icon && <div className={styles['announcement-bar__icon']}>{icon}</div>}

      <div className={styles['announcement-bar__content']}>
        <div className={styles['announcement-bar__content__title']}>
          {title}
        </div>

        {description && (
          <div className={styles['announcement-bar__content__desc']}>
            {description}
          </div>
        )}
      </div>

      <div className={styles['announcement-bar__action-btns']}>
        {actionBtnsProps?.map((btn, i) => (
          <Button key={`announcement-box-action-btn-${i}`} {...btn} />
        ))}
      </div>
    </div>
  );
};
